import React, { useEffect, useState } from 'react';
import { loadStats, formatTime } from '../utils/statsUtils.js';

const S = {
  page: { minHeight: '100vh', backgroundColor: '#0d1b0f', backgroundImage: 'radial-gradient(ellipse at 50% 30%, rgba(45,106,79,0.4) 0%, transparent 60%)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem', fontFamily: "Lato, sans-serif" },
  card: { background: 'rgba(0,0,0,0.4)', border: '1px solid rgba(201,168,76,0.3)', borderRadius: '8px', padding: '2.5rem', width: '100%', maxWidth: '420px', display: 'flex', flexDirection: 'column', gap: '1.5rem' },
  title: { fontFamily: "Playfair Display, serif", color: '#c9a84c', fontSize: '1.75rem', fontWeight: '700', letterSpacing: '0.2em', textTransform: 'uppercase', margin: 0, textAlign: 'center' },
  statRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(201,168,76,0.1)', paddingBottom: '0.75rem' },
  statLabel: { color: 'rgba(245,230,200,0.6)', fontSize: '0.8rem', letterSpacing: '0.1em', textTransform: 'uppercase' },
  statValue: { color: '#c9a84c', fontSize: '1.25rem', fontWeight: '700', fontFamily: "Playfair Display, serif" },
  btnOutline: { background: 'transparent', color: '#c9a84c', border: '1px solid rgba(201,168,76,0.4)', padding: '0.85rem', fontSize: '0.85rem', fontFamily: "Lato, sans-serif", letterSpacing: '0.1em', textTransform: 'uppercase', cursor: 'pointer', borderRadius: '2px', width: '100%' },
};

export default function StatsScreen({ userId, username, onBack }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetch() {
      const data = await loadStats(userId);
      setStats(data);
      setLoading(false);
    }
    fetch();
  }, [userId]);

  const winRate = stats && (stats.wins + stats.losses) > 0
    ? Math.round((stats.wins / (stats.wins + stats.losses)) * 100)
    : 0;

  return (
    <div style={S.page}>
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, height: '4px', background: 'linear-gradient(90deg, transparent, #c9a84c, #f0c040, #c9a84c, transparent)' }} />

      <div style={S.card}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '2.5rem', color: '#c9a84c', marginBottom: '0.5rem' }}>🏆</div>
          <h1 style={S.title}>My Stats</h1>
          <p style={{ color: 'rgba(201,168,76,0.5)', fontSize: '0.75rem', letterSpacing: '0.1em', textTransform: 'uppercase', margin: 0 }}>
            {username || 'Player'} — Pounce League
          </p>
        </div>

        {loading && <p style={{ color: '#c9a84c', textAlign: 'center' }}>Loading stats...</p>}

        {!loading && stats && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <div style={S.statRow}>
              <span style={S.statLabel}>Wins</span>
              <span style={{ ...S.statValue, color: '#4ade80' }}>{stats.wins}</span>
            </div>
            <div style={S.statRow}>
              <span style={S.statLabel}>Losses</span>
              <span style={{ ...S.statValue, color: '#f87171' }}>{stats.losses}</span>
            </div>
            <div style={S.statRow}>
              <span style={S.statLabel}>Win Rate</span>
              <span style={S.statValue}>{winRate}%</span>
            </div>
            <div style={S.statRow}>
              <span style={S.statLabel}>Best Win Streak</span>
              <span style={S.statValue}>{stats.win_streak} 🔥</span>
            </div>
            <div style={S.statRow}>
              <span style={S.statLabel}>Current Streak</span>
              <span style={S.statValue}>{stats.current_streak}</span>
            </div>
            <div style={S.statRow}>
              <span style={S.statLabel}>Fastest Round</span>
              <span style={S.statValue}>{formatTime(stats.fastest_round)}</span>
            </div>
            <div style={S.statRow}>
              <span style={S.statLabel}>Total Cards Played</span>
              <span style={S.statValue}>{stats.cards_played}</span>
            </div>
          </div>
        )}

        {!loading && !stats && (
          <p style={{ color: 'rgba(245,230,200,0.5)', textAlign: 'center', fontSize: '0.85rem' }}>No stats yet — play a game to get started!</p>
        )}

        <button style={S.btnOutline} onClick={onBack}>← Back to Main Menu</button>
      </div>

      <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, height: '4px', background: 'linear-gradient(90deg, transparent, #c9a84c, #f0c040, #c9a84c, transparent)' }} />
    </div>
  );
}
